/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserLayoutRequest} from '../models/UserLayoutRequest';
import type {UserLayoutResponse} from '../models/UserLayoutResponse';

export interface GetLayoutCounts$Request {
    userId: number;
}

export interface GetLayoutCounts$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getLayoutCountsRequest = createAction<PayloadData<void, GetLayoutCounts$Request>>('USER_LAYOUTS__GET_LAYOUT_COUNTS__REQUEST');
export const getLayoutCountsSuccess = createAction<PayloadData<{ [key: string]: number; }, GetLayoutCounts$Request>>('USER_LAYOUTS__GET_LAYOUT_COUNTS__SUCCESS');
export const getLayoutCountsFailure = createAction<PayloadData<Error, GetLayoutCounts$Request, true>>('USER_LAYOUTS__GET_LAYOUT_COUNTS__FAILURE');

export const getLayoutCountsActions = [
    getLayoutCountsRequest,
    getLayoutCountsSuccess,
    getLayoutCountsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getLayoutCounts = (meta: GetLayoutCounts$Request, config?: GetLayoutCounts$Config) => {
    return {
        CALL_API: {
            types: getLayoutCountsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/contents/layouts/counts`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetUserLayouts$Request {
    userId: number;
    userLayoutRequest?: UserLayoutRequest;
}

export interface GetUserLayouts$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserLayoutsRequest = createAction<PayloadData<void, GetUserLayouts$Request>>('USER_LAYOUTS__GET_USER_LAYOUTS__REQUEST');
export const getUserLayoutsSuccess = createAction<PayloadData<UserLayoutResponse, GetUserLayouts$Request>>('USER_LAYOUTS__GET_USER_LAYOUTS__SUCCESS');
export const getUserLayoutsFailure = createAction<PayloadData<Error, GetUserLayouts$Request, true>>('USER_LAYOUTS__GET_USER_LAYOUTS__FAILURE');

export const getUserLayoutsActions = [
    getUserLayoutsRequest,
    getUserLayoutsSuccess,
    getUserLayoutsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserLayoutRequest} [meta.userLayoutRequest]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserLayouts = (meta: GetUserLayouts$Request, config?: GetUserLayouts$Config) => {
    return {
        CALL_API: {
            types: getUserLayoutsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/${meta.userId}/contents/layouts`,
            TRANSPORT_REQUEST_BODY: meta.userLayoutRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

